import http from '@/http-common';

class FinanceiroCaixaMovService {
  async abrirCaixa(inputModel) {
    return http.post('/financeiroCaixaMov/abrirCaixa', inputModel);
  }

  async verifyCaixaAberto(inputModel) {
    return http.post('/financeiroCaixaMov/verifyCaixaAberto', inputModel);
  }

  async fecharCaixa(inputModel) {
    return http.post('/financeiroCaixaMov/fecharCaixa', inputModel);
  }

  async getValoresDisponivel(ide) {
    return http.get(`/financeiroCaixaMov/saldoDisponivel/${ide}`);
  }

  async entradaCaixa(inputModel) {
    return http.post('/financeiroCaixaMov/entradaCaixa', inputModel);
  }

  async retiradaCaixa(inputModel) {
    return http.post('/financeiroCaixaMov/retiradaCaixa', inputModel);
  }

  async retiradaComContaPagar(inputModel) {
    return http.post('/financeiroCaixaMov/retiradaComContaPagar', inputModel);
  }

  async ultimoSaldoDinheiro(input) {
    return http.post('/financeiroCaixaMov/ultimoSaldoDinheiro', input);
  }

  async consultarCaixasFechamento(input) {
    return http.post('/financeiroCaixaMov/consultarCaixasFechamento', input);
  }

  async visualizarRelatorioCaixa(input) {
    return http.post('/financeiroCaixaMov/visualizarRelatorioCaixa', input);
  }
}

export default new FinanceiroCaixaMovService();
